import React from 'react';
import TextField from '@material-ui/core/TextField';

const Qty = ({unitName, curQty, changeField}) => {
  return (
    <TextField
      label={unitName}
      value={curQty}
      onChange={(e) => changeField(e.target.value)}
      margin="dense"
      variant="outlined"
      type="text"
      style={{ width: 125 }}
      inputProps={{ maxLength: 5 }}
    />
  )
}

export default Qty



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/Qty.js